import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path, Rect } from './base/Icon';
type Props = {
  height?: number;
  color?: string;
  bgColor?: string;
  rounded?: boolean;
};
const Logo = t0 => {
  const $ = _c(9);
  const {
    height: t1,
    bgColor: t2,
    color: t3,
    rounded: t4
  } = t0;
  const height = t1 === undefined ? 100 : t1;
  const bgColor = t2 === undefined ? "#6366F1" : t2;
  const color = t3 === undefined ? "white" : t3;
  const rounded = t4 === undefined ? false : t4;
  const borderRadius = rounded ? 20 : 0;
  let t5;
  if ($[0] !== bgColor || $[1] !== borderRadius) {
    t5 = <Rect width={100} height={100} fill={bgColor} rx={borderRadius} ry={borderRadius} />;
    $[0] = bgColor;
    $[1] = borderRadius;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== color) {
    t6 = <Path d="M56.22 31.73C51.46 31.73 47.8617 32.7783 45.425 34.875C42.9883 36.915 41.77 40.0033 41.77 44.14V47.795H66.25V58.845H41.77V80.52H28V44.225C28 36.575 30.38 30.625 35.14 26.375C39.9567 22.125 46.6717 20 55.285 20C58.685 20 61.8867 20.3683 64.89 21.105C67.8933 21.785 70.5 22.805 72.71 24.165L68.46 35.045C65.06 32.835 60.98 31.73 56.22 31.73Z" fill={color} />;
    $[3] = color;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== height || $[6] !== t5 || $[7] !== t6) {
    t7 = <Icon viewBox="0 0 100 100" height={height} width={height} fill="none">{t5}{t6}</Icon>;
    $[5] = height;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default Logo;